export default __webpack_public_path__ + "static/media/trash.aba8a797.svg";